//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"ButtOption",1,0],[0,"CopeOption",1,0],[0,"CustomGroupController",1,0],[1,"Cutback",0,"Expression",0],[0,"DefaultGroup1Controller",1,0],[0,"DefaultGroup2Controller",1,0],[0,"DefaultGroup3Controller",1,0],[0,"DefaultGroupController",1,0],[0,"HorizontalCornerType",1,0],[0,"InnerCornerType",1,0],[0,"Placement",1,0],[0,"VerticalCornerType",1,0]],[],[]];
SPLM.Features.StructureDesign.RuleBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.RuleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.RuleBuilder.Placements = Object.freeze({
    "Inside" : "Inside", "Center" : "Center", "Outside" : "Outside"});

SPLM.Features.StructureDesign.RuleBuilder.CornerTypes = Object.freeze({
    "None" : "None", "Miter" : "Miter", "Butt" : "Butt", "Cope" : "Cope", "MatchedCope" : "MatchedCope"});

SPLM.Features.StructureDesign.RuleBuilder.CustomConfigs = Object.freeze({
    "Choose" : "Choose", "None" : "None"});

SPLM.Features.StructureDesign.RuleBuilder.DefaultConfigs = Object.freeze({
    "Choose" : "Choose", "None" : "None"});

SPLM.Features.StructureDesign.RuleBuilder.DefaultGroup1Configs = Object.freeze({
    "Choose" : "Choose", "None" : "None"});

SPLM.Features.StructureDesign.RuleBuilder.DefaultGroup2Configs = Object.freeze({
    "Choose" : "Choose", "None" : "None"});

SPLM.Features.StructureDesign.RuleBuilder.DefaultGroup3Configs = Object.freeze({
    "Choose" : "Choose", "None" : "None"});

SPLM.Features.StructureDesign.RuleBuilder.ButtOptions = Object.freeze({
    "ButtShortest" : "ButtShortest", "ButtLongest" : "ButtLongest"});

SPLM.Features.StructureDesign.RuleBuilder.CopeOptions = Object.freeze({
    "CopeShortest" : "CopeShortest", "CopeLongest" : "CopeLongest"});

export default SPLM;